/* global google */

import React, { Component } from "react";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import SearchBox from "react-google-maps/lib/components/places/SearchBox";
import _ from "lodash";
import Geocode from "react-geocode";
require('dotenv').config()

const Map = withScriptjs(
  
    withGoogleMap(props => (
        <GoogleMap
            defaultZoom={10}
            center={props.center}
            ref={props.onMapMounted}
            onRightClick={props.onMapClick}
            onDblClick={props.onDblClick}
        >
        <SearchBox
            controlPosition={google.maps.ControlPosition.TOP_LEFT}
            ref={props.onSearchBoxMounted}
            onPlacesChanged={e => props.onPlacesChanged(e)}
        >
          <input
            type="text"
            placeholder="Buscar dirección aquí"
            disabled={props.disabled}
            autoComplete="off"
            onFocus={e => props.onFocus(e)}            
            onChange={e => props.onChange(e)}
            value={props.value}
            style={{
              boxSizing: `border-box`,
              border: `1px solid transparent`,
              width: `240px`,
              height: `32px`,
              marginTop: `27px`,
              padding: `0 12px`,
              borderRadius: `3px`,
              boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
              fontSize: `14px`,
              outline: `none`,
              textOverflow: `ellipses`,
            }}
          />
        </SearchBox>
        {props.marks.map((mark, index) => (
            <Marker
                key={index}
                position={mark}
                radius={10000}
                options={{
                    strokeColor: "#66009a",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: `#66009a`,
                    fillOpacity: 0.35,
                    zIndex: 1
                }}
            />
        ))}
        </GoogleMap>
    ))
);

class googleMaps extends Component {

    constructor(props) {
      super(props);
      var lat = parseFloat(process.env.REACT_APP_AUTOCORP_LAT)
      var long = parseFloat(process.env.REACT_APP_AUTOCORP_LONG)
      this.state = {
        marks: [],
        center: { lat: lat, lng: long },
        markers:[],
        google_api_key:process.env.REACT_APP_GOOGLE_KEY
      };
      this.onSearch = this.onSearch.bind(this)
    }

    componentDidMount(){
      let updated = false
      var marks=[]
      const google_api_key = this.state.google_api_key
      var places = this.props.places
      this.props.places.map((val, idx) => {
        if (val[0].formatted_address !== undefined){
          marks.push(val[0].geometry.location)
        } else {
            let address = {}
            updated = true
            Geocode.setApiKey(google_api_key);
            Geocode.setLanguage("es");
            Geocode.setRegion("es");
            Geocode.enableDebug();
            Geocode.fromLatLng(val[0].geometry.location.lat, val[0].geometry.location.lng).then(
                    response => {
                      address = response;
                      if ((address.results[0].types.includes('street_address'))){
                        var new_address = []
                        new_address.push(address.results[0])
                        places[idx] = new_address
                      }

                      if ((address.results[1].types.includes('street_address'))){
                        var new_address = []
                        new_address.push(address.results[1])
                        places[idx] = new_address
                      }
                    },
                    error => {
                      console.error(error);
                    }
                  );          
        }
      })

      const nextMarkers = this.props.places.map(place => ({
        position: place[0].geometry.location,
      }));

      const nextCenter = _.get(nextMarkers, '0.position', this.state.center);
      this.setState({marks: marks, markers: this.props.places, center: nextCenter})
      if (updated === true){
        this.props.onChange(places);
      }
    }

    onSearch(e){
      this.setState({address_search: e.target.value})
    }

    findAddressPart = (result, part) => {
      if (result){
        const component = result.find(c => c.types.indexOf(part) !== -1)
        if(component) {
          return true
        }
      }
      return false
    }
    validatePlaces(places){
      var valid_places = true
      places.map((place,idx)=>{
      let address = place.address_components
/*        valid_places = valid_places && (
        ( this.findAddressPart(address, 'locality') || this.findAddressPart(address, 'sublocality_level_1') )
        && ( this.findAddressPart(address, 'administrative_area_level_1') || this.findAddressPart(address, 'administrative_area_level_2') ) 
        && this.findAddressPart(address, 'route')
        && this.findAddressPart(address, 'street_number') );*/
        if (!this.findAddressPart(address, 'street_number')){
          var new_address = [{long_name: 'S/N', short_name:'S/N', types:['street_number']}].concat(address)
          places[idx].address_components = new_address
        }

      })

      return places
    }

    onFocus = event => {
      if(event.target.autocomplete){
        event.target.autocomplete = "whatever";
      }
    }
    onMapChanged = props =>{
      var places = this.state.searchBox.getPlaces();
      if (places[0].address_components){
        const bounds = new google.maps.LatLngBounds();
        var valid_places = this.validatePlaces(places)

        places = valid_places

        places.forEach(place => {
          if (place.geometry.viewport) {
            bounds.union(place.geometry.viewport)
          } else {
            bounds.extend(place.geometry.location)
          }
        });

        const nextMarkers = places.map(place => ({
          position: place.geometry.location,
        }));


        const nextCenter = _.get(nextMarkers, '0.position', this.state.center);
        let markers = this.props.places;
        markers.push(places)
        this.setState({
          center: nextCenter,
          markers: markers,
        });
        this.setState({marks: [...this.state.marks, places[0].geometry.location]})
        
        if (this.props.onChange) {
          this.setState({address_search: ''})
          this.props.onChange(this.state.markers);
        }
      }
    }

    onSearchBoxMounted = ref => {
      this.setState({searchBox: ref});
    }

    onMapMounted= ref => {
      this.setState({ref: ref})
    }

    setMark = (e)=>{

      if (!this.props.disabled){
        let address = {}
        var google_api_key = this.state.google_api_key
        Geocode.setApiKey(google_api_key);
        Geocode.setLanguage("es");
        Geocode.setRegion("es");
        Geocode.enableDebug();
        Geocode.fromLatLng(e.latLng.lat(), e.latLng.lng()).then(
          response => {
            address = response;
            if ((address.results[0].types.includes('street_address'))){
              var new_address = []
              address.results[0].geometry.location = e.latLng
              new_address.push(address.results[0])
              this.setState({markers: [...this.state.markers, new_address]})
              this.setState({marks: [...this.state.marks, e.latLng]})
              this.props.onChange(this.state.markers);
            }
          },
          error => {
            console.error(error);
          }
        );
      }
    }

    render() {
      var marks=[]
      this.props.places.map((val, idx)=>{
        marks.push(val[0].geometry.location)
      })
        const google_api_key = this.state.google_api_key
        return (
            <div className="row">
                <div className="col col-sm-12">
                  <Map
                      googleMapURL={"https://maps.googleapis.com/maps/api/js?key="+google_api_key+"&v=3.exp&libraries=geometry,drawing,places"}
                      loadingElement={<div style={{ height: `100%` }} />}
                      containerElement={<div style={{ height: `400px` }} />}
                      mapElement={<div style={{ height: `100%` }} />}
                      marks={marks}
                      center={this.state.center}
                      onPlacesChanged={this.onMapChanged}
                      onFocus={this.onFocus}
                      onMapClick={this.setMark}
                      onSearchBoxMounted={this.onSearchBoxMounted}
                      onMapMounted={this.onMapMounted}
                      disabled={this.props.disabled}
                      value={this.state.address_search}
                      onChange={this.onSearch}
                  />
                </div>
              </div>
        );
    }
}

export default googleMaps;